import { Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { HeartHandIcon } from 'assets/svg';
import { useAppDispatch, useAppSelector } from 'features/app/hooks';
import { closeCallAfterReport } from 'features/call/vrs-call-comments/store';
import styled from 'features/theme/styled';
import theme from 'features/theme/theme';
import { Button } from 'features/ui/elements';
import { useLeaveQueue } from 'features/leave-queue/hooks';
import { readyForNextCall } from 'features/call/call-ui-state/store';
import { callTypeSelector } from 'features/call/call-base/store/selectors';
import { useVrsCallFinishConference } from 'features/call/vrs-conference-call/hooks';
import { CallType } from 'features/call/call-base/enums';

export const VrsCallCommentsEnd = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation('translation', {
    keyPrefix: 'callCommentsEnd',
  });
  const [isLoading, setIsLoading] = useState(false);
  const callType = useAppSelector(callTypeSelector);
  const { handleCloseCallVrsConference } = useVrsCallFinishConference();

  const { handleLeaveQueue } = useLeaveQueue();

  const handleReadyForMoreCalls = async () => {
    try {
      setIsLoading(true);
      if (callType === CallType.CONFERENCE_CALL) {
        await handleCloseCallVrsConference(true);
      } else {
        await dispatch(closeCallAfterReport());
      }
      dispatch(readyForNextCall());
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const leaveQueue = async () => {
    setIsLoading(true);
    await dispatch(closeCallAfterReport());
    handleLeaveQueue();
    setIsLoading(false);
  };

  return (
    <Container>
      <HeartHandIcon />
      <Typography
        variant='h1'
        color={theme.palette.common.white}
        align='center'
        whiteSpace='pre-line'
        mt={12}
      >
        {t('title')}
      </Typography>
      <Typography variant='body1' color={theme.palette.grey[50]} mt={16}>
        {t('subtitle')}
      </Typography>
      <ReadyForMoreCallsBtn
        fullWidth
        size='large'
        color='primary'
        title={t('readyForMoreCalls')}
        onClick={handleReadyForMoreCalls}
        disabled={isLoading}
      >
        {t('readyForMoreCalls')}
      </ReadyForMoreCallsBtn>
      <TakeBreakBtn
        fullWidth
        size='small'
        color='secondary'
        title={t('takeBreak')}
        onClick={leaveQueue}
        disabled={isLoading}
      >
        {t('takeBreak')}
      </TakeBreakBtn>
    </Container>
  );
};

const Container = styled('div')`
  width: 550px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${theme.palette.grey[900]};
  border-radius: 8px;
  padding: ${theme.spacing(31, 23, 23)};
`;

const ReadyForMoreCallsBtn = styled(Button)`
  margin-top: ${theme.spacing(16)};
`;

const TakeBreakBtn = styled(Button)`
  margin-top: ${theme.spacing(8)};
`;
